import React from 'react';
import { Icon } from './Icon.js';
export const IconProgressBar = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("polygon", { points: "12.5 3 10 6 7.5 3 12.5 3", fill: "currentColor", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("path", { d: "m15,9H5c-2.206,0-4,1.794-4,4s1.794,4,4,4h10c2.206,0,4-1.794,4-4s-1.794-4-4-4Zm-5,5h-5c-.552,0-1-.448-1-1s.448-1,1-1h5c.552,0,1,.448,1,1s-.448,1-1,1Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconProgressBar.js.map